import React, { useContext } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { edit2 } from 'react-icons-kit/feather'
// import QuickItems from '../../../components/MyBiye/QuickItems/Index'
import { UserContext } from '../../../utils/context/userContext'
// import Slider from 'rc-slider';
// import 'rc-slider/assets/index.css';
import { HeightCalculatetoNumber } from '../../../utils/helpers'
import Loading from '../../../components/Loading/Index'
import { useNavigate } from 'react-router-dom'


const Index = () => {

    let navigate = useNavigate();
    const { user } = useContext(UserContext)
    // const { Range } = Slider;
    const data =  user?.partnerPreference
    console.log(data);

    const changeUrl = () => {
        navigate('/my-dashboard/profile?dv=parpre')
    }
    if (!user) return <Loading />

    return (
        <div className="preference-container">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="d-lg-flex">
                            {/* <QuickItems /> */}

                            <div className="flex-fill main-section px-lg-4 pt-4 pt-lg-0 pb-4">
                                <div className="d-flex justify-content-between mb-4">
                                    <div className="mb-0"><h4>Overviews</h4></div>
                                    <div className="ml-auto ">
                                        <button className="btn rounded-circle shadow"
                                            onClick={changeUrl}
                                        >
                                            <Icon icon={edit2} size={20} />
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    {/* Section Card */}
                                    <div className="card mb-4 border-0 shadow-sm">

                                        <div className="card-body">
                                            <div className="row g-4">

                                                <div className="col-md-4">
                                                    <small className="text-muted">Marital Status</small>
                                                    <div className="text-capitalize">{data?.materialStatus ? data.materialStatus : "Not Available"}</div>
                                                </div>

                                                <div className="col-md-4">
                                                    <small className="text-muted">Religion / Community</small>
                                                    <div className="text-capitalize">{data?.religion ? data.religion : "Not Available"}</div>
                                                </div>

                                                <div className="col-md-4">
                                                    <small className="text-muted">Mother Tongue</small>
                                                    <div className="text-capitalize">{data?.motherTongue ? data.motherTongue : "Not Available"}</div>
                                                </div>

                                                <div className="col-md-4">
                                                    <small className="text-muted">Age</small>
                                                    <div>{data?.ageRange
                                                        ? `${data.ageRange.startFrom} - ${data.ageRange.endTo}Years`
                                                        : "Not Available"}</div>
                                                </div>

                                                <div className="col-md-4">
                                                    <small className="text-muted">Height</small>
                                                    <div>{data?.heightRange && data?.heightRange?.startFrom !== null ?
                                                        `${HeightCalculatetoNumber(data.heightRange.startFrom)} - ${HeightCalculatetoNumber(data.heightRange.endTo)} ft` : "Not Available"}
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <small className="text-muted">Diet</small>
                                                    <div className="text-muted fst-italic text-capitalize">
                                                        {data?.diet ? data.diet : "Doesn't matter"}

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    {/* Location & grew up in details */}
                                    <div className="card mb-4 border-0 shadow-sm">
                                        <div className="card-header d-flex justify-content-between">
                                        <strong>Location & grew up in details</strong>
                                        {/* <button className="btn btn-sm btn-light">✏</button> */}
                                        </div>

                                        <div className="card-body">
                                        <div className="row g-4">
                                            
                                            {/* Living country */}
                                            <div className="col-md-4">
                                            <small className="text-muted">Country</small>
                                            <div>{data?.location?.country.length ? data.location.country : "Non Available"}</div>
                                            </div>
                                            
                                            {/* Living state */}
                                            <div className="col-md-4">
                                            <small className="text-muted">Living state / Divition</small>
                                            <div>{data?.location?.stateDivision.length ? data.location.stateDivision : "Non Available"}</div>
                                            </div>

                                            {/* Residency status */}
                                            <div className="col-md-4">
                                            <small className="text-muted">City</small>
                                            <div>{data?.location?.city.length ? data.location.city : "Non Available"}</div>
                                            </div>

                                            <div className="col-12">
                                            <div className="border rounded p-4 text-center text-muted">
                                                Map Placeholder
                                            </div>
                                            </div>

                                        </div>
                                        </div>
                                    </div>

                                    {/* Education & profession details */}
                                    <div className="card mb-4 border-0 shadow-sm">
                                        <div className="card-header d-flex justify-content-between">
                                        <strong>Education & profession details</strong>
                                        {/* <button className="btn btn-sm btn-light">✏</button> */}
                                        </div>

                                        <div className="card-body">
                                        <div className="row g-4">
                                            {/* Qualification */}
                                            <div className="col-md-6">
                                            <small className="text-muted">Qualification</small>
                                            <div>{data?.educationAndProfession?.qualification.length ? data.educationAndProfession.qualification : "Non Available"}</div>
                                            </div>
                                            
                                            {/* Profession area */}
                                            <div className="col-md-6">
                                            <small className="text-muted">Profession area</small>
                                            <div>{data?.educationAndProfession?.professionArea.length ? data.educationAndProfession.professionArea : "Non Available"}</div>
                                            </div>
                                            
                                            {/* Working with */}
                                            <div className="col-md-6">
                                            <small className="text-muted">Working With</small>
                                            <div>{data?.educationAndProfession?.workingWith.length ? data.educationAndProfession.workingWith : "Non Available"}</div>
                                            </div>
                                            
                                            {/* Annual income */}
                                            <div className="col-md-6">
                                            <small className="text-muted">Annual income</small>
                                            <div>{data?.annualIncome?.startFrom ? `${data.annualIncome.startFrom}-${data.annualIncome.endTo}` : "Doesn't Matter"}</div>
                                            </div>

                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Index;

